var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavIcon8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#141414"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3732_859)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.375 22H28.8838L28.0001 22.8838V24.375H29.8751C30.2201 24.375 30.5001 24.655 30.5001 25C30.5001 25.345 30.2201 25.625 29.8751 25.625H28.0001V27.1162L28.8838 28H32.375C32.72 28 33 28.28 33 28.625V32.375C33 32.72 32.72 33 32.375 33H28.625C28.28 33 28 32.72 28 32.375V28.8838L27.1162 28.0001H25.625V29.8751C25.625 30.2201 25.345 30.5001 25 30.5001C24.655 30.5001 24.375 30.2201 24.375 29.8751V28.0001H22.8838L22 28.8838V32.375C22 32.72 21.72 33 21.375 33H17.625C17.28 33 17 32.72 17 32.375V28.625C17 28.28 17.28 28 17.625 28H21.1162L21.9999 27.1162V25.625H20.1249C19.7799 25.625 19.4999 25.345 19.4999 25C19.4999 24.655 19.7799 24.375 20.1249 24.375H21.9999V22.8838L21.1162 22H17.625C17.28 22 17 21.72 17 21.375V17.625C17 17.28 17.28 17 17.625 17H21.375C21.72 17 22 17.28 22 17.625V21.1162L22.8838 21.9999H24.375V20.1249C24.375 19.7799 24.655 19.4999 25 19.4999C25.345 19.4999 25.625 19.7799 25.625 20.1249V21.9999H27.1162L28 21.1162V17.625C28 17.28 28.28 17 28.625 17H32.375C32.72 17 33 17.28 33 17.625V21.375C33 21.72 32.72 22 32.375 22ZM31.7501 18.25H29.2501V20.75H31.7501V18.25ZM20.7501 18.25H18.2502V20.75H20.7501V18.25ZM18.2502 31.7499H20.7501V29.2499H18.2502V31.7499ZM26.7501 23.2499H23.2501V26.7499H26.7501V23.2499ZM29.2501 31.7499H31.7501V29.2499H29.2501V31.7499ZM25.6251 25C25.6251 25.8331 24.3751 25.8331 24.3751 25C24.3751 24.1669 25.6251 24.1669 25.6251 25Z",
    fill: "#F2F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3732_859"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(17 17)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIcon8);
export default __webpack_public_path__ + "static/media/nav_icon_8.f08b096ff582cfc3150a220e9a01e082.svg";
export { ForwardRef as ReactComponent };